import { render } from "./010-VRParkFairyTale.vue?vue&type=template&id=faacd946&scoped=true"
import script from "./010-VRParkFairyTale.vue?vue&type=script&lang=js"
export * from "./010-VRParkFairyTale.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=faacd946&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faacd946"]])

export default __exports__